import { Injectable } from '@angular/core';
import { Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Storage } from '@ionic/storage-angular';

@Injectable({ providedIn: 'root' })
export class RouteGuard  {
    constructor(
        private router: Router,
        private storage: Storage,

    ) {
        this.storage.create();
    }

    async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        const currentUser = await this.getCurrentUser();
        if (currentUser || location.hostname === "localhost") {
            return true;
        } else {
            window.location.href = 'https://apps.1risk.cloud';
            return false;
        }
    }

    async getCurrentUser() {
        if (this.storage) {
            return this.storage.get('user');
        } else { return false; }
    }
}